export default __webpack_public_path__ + "static/media/xcovers-2-rMIN.e762fa18.jpg";